<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import FallbackAvatar from '@/components/ui/FallbackAvatar'
import LanguageSwitcher from '@/components/ui/LanguageChanger'
import NavigationItem from '@/components/navigation/NavigationItem'
import api from '@/api'

export default {
  name: 'AppNavigation',
  components: {
    FallbackAvatar,
    LanguageSwitcher,
    NavigationItem,
  },
  props: {
    activityBgColor: {
      type: String,
      default: 'accent',
    },
    appendSearch: Boolean,
    navigationBgColor: {
      type: String,
      default: 'main-darken-5',
    },
    prependSearch: Boolean,
    routes: Array,
    settingsRoutes: Array,
    showLanguageSwitcher: Boolean,
    user: Object,
    value: Boolean,
    right: {
      type: Boolean,
      default: true,
    },
    advancedSearchType: String,
  },
  data() {
    return {
      open: false,
      search: null,
      isSettingsMenu: false,
    }
  },
  computed: {
    ...mapState('activities', ['unread_activities']),
    ...mapState('auth', [
      'location',
      'settings',
    ]),
    links() {
      const links = []
      if (process.env.NODE_ENV === 'development') {
        links.push({ title: 'Dummy', icon: this.iconMapping('dummy'), type: 'dummy' })
      }
      return links
    },
    getLogo() {
      const logo =
        this.settings &&
        this.settings.base_options &&
        this.settings.base_options.show_company_logo &&
        this.location &&
        this.location.image
          ? this.location.image
          : this.customerConfig.images.logo
      return logo
    },
  },
  watch: {
    value: {
      handler() {
        this.open = this.value
        this.isSettingsMenu = false
      },
      immediate: true,
    },
    open() {
      this.$emit('input', this.open)
    },
  },
  created() {
    if (this.user) {
      this.getCountUnreadActivities()
    }
  },
  methods: {
    ...mapActions('activities', ['getCountUnreadActivities']),
    ...mapActions('auth', ['getSettingsMenu']),
    onSearch() {
      if (!this.search) return false

      if (this.$route.name === 'search-results' && this.$route.query.q !== this.search) {
        this.$router.push({ query: { q: this.search } })
      } else if (this.$route.query.q !== this.search) {
        this.$router.push({ name: 'search-results', query: { q: this.search } })
      }

      this.search = null
    },
    toggleAction(url) {
      api.items.editItem(url).then(_ => {
        this.getSettingsMenu()
      })
    },
  },
}
</script>
